import { cn } from '@/lib/utils'

interface TourHeaderProps {
  children: React.ReactNode
  className?: string
}

export function TourHeader({ children, className }: TourHeaderProps) {
  return <div className={cn('flex flex-col space-y-2 mb-4', className)}>{children}</div>
}
